// @flow

import * as React from 'react';
import cn from 'classnames';

import { share } from 'client/utils/share';
import { IS_DEVEL } from 'common/constants';
import { dataLayerEvents } from 'common/utils/gtag';
import { SHARE_CONSTANTS } from 'client/constants';
import whatsAppIcon from 'assets/client/images/socials/whatsapp.png';
import facebookIcon from 'assets/client/images/socials/facebook.svg';
// import instaIcon from 'assets/client/images/socials/insta.png';
// import { Icon } from '../Icon';
import * as css from './Socials.scss';

type Props = {
	className?: string,
};

type State = {
	isOpen: boolean,
};

type ReactObjRef = { current: HTMLDivElement | null };
export default class Socials extends React.Component<Props, State> {
	sociallsRef: ReactObjRef;
	static defaultProps = {
		className: '',
	};

	state = {
		isOpen: false,
	};

	constructor(props: Props) {
		super(props);
		this.state = {
			isOpen: false,
		};
		this.sociallsRef = React.createRef();
	}

	componentDidMount() {
		document.addEventListener('click', this.documentClickListener);
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.documentClickListener);
	}

	documentClickListener = (e: MouseEvent) => {
		if (this.sociallsRef.current) {
			if (this.sociallsRef.current.contains((e.target: any))) return false;
		}

		this.setState({
			isOpen: false,
		});
	};

	toggleOpenMenu = (e: SyntheticEvent<HTMLDivElement>) => {
		this.setState(prevState => ({
			isOpen: !prevState.isOpen,
		}));
	};

	onShare = (e: SyntheticEvent<HTMLButtonElement>) => {
		const type = e.currentTarget.dataset.id;
		// events.onShareClick(type, this.props.shareCategory);

		if (!IS_DEVEL) {
			dataLayerEvents.onShareBtnClick(type);

			share(type);
		}
	};

	render() {
		const { className } = this.props;

		return (
			<div className={cn(css.socials, this.state.isOpen && css.open, className)} ref={this.sociallsRef}>
				<div className={css.overflowWrap}>
					<button type="button" className={css.socialButton} data-id={SHARE_CONSTANTS.WHATSAPP} onClick={this.onShare}>
						<img src={whatsAppIcon} alt="whatsapp" className={cn(css.iconWhatsapp, css.icon)} />
					</button>
					{/* <button
						className={css.socialButton}
						type="button"
						data-id={SHARE_CONSTANTS.INSTAGRAM}
						onClick={this.onShare}
					>
						<img src={instaIcon} alt="instagram" className={cn(css.iconInsta, css.icon)} />
					</button> */}
					<button className={css.socialButton} type="button" data-id={SHARE_CONSTANTS.FACEBOOK} onClick={this.onShare}>
						<img src={facebookIcon} alt="facebook" className={cn(css.iconWhatsapp, css.icon)} />
					</button>
				</div>
			</div>
		);
	}
}
